import { css, type SerializedStyles } from '@emotion/react';
import { TextButton1CAPSRBMixin, TextH2OMMixin } from '@mobalytics/shared';
import * as React from 'react';
import { getCurrencySymbol } from '../../../utils/get-currency-symbol.utils';

interface Props {
  className?: string;

  currency: string | null;
  price: number;
  timeframe: string;

  priceCssOverride?: SerializedStyles;
  durationLabelCssOverride?: SerializedStyles;
  currencyCssOverride?: SerializedStyles;
}

export const PricePerTimeframe: React.FC<Props> = (props) => {
  const { className, currency, price, timeframe, priceCssOverride, durationLabelCssOverride, currencyCssOverride } =
    props;
  return (
    <div css={wrapperCss} className={className}>
      {currency && <span css={[currencyCss, currencyCssOverride]}>{getCurrencySymbol(currency)}</span>}
      <div css={priceWrapperCss}>
        <span css={[priceCss, priceCssOverride]}> {price}</span>
        <span css={[durationLabel, durationLabelCssOverride]}> / {timeframe}</span>
      </div>
    </div>
  );
};

const wrapperCss = css`
  display: flex;
  align-items: center;
`;

const priceCss = css`
  ${TextH2OMMixin};
  font-weight: 500;
  margin-left: 4px;
`;

const currencyCss = css`
  ${TextButton1CAPSRBMixin};
  margin-bottom: 12px;
`;

const priceWrapperCss = css`
  display: flex;
  align-items: baseline;
`;

const durationLabel = css`
  ${TextButton1CAPSRBMixin};
  text-transform: lowercase;
  margin-left: 4px;
`;
